
import { useState ,useEffect } from "react";
import ButtonContainer from "./buttonContainer";
import TextFieldCustom from "../../../../component/elements/textfieldCustom/index";
import { validateForm } from "../../../../utils/formValidation/validation";
import { otherDetailsRules } from "../../../../utils/formValidation/validationRules";

function OtherDetails({nextHandler,previousHandler ,mode ,formValues}) {
    const [formData, setFormData] = useState({
      vechicalType: "",
      licencePlateNumber: "",
    });
    const [formErrors, setFormErrors] = useState({});

      useEffect(() => {
      if (formValues) {
        setFormData(formValues);
      }
    }, [formValues]);
    
      const handleChange = (field) => (e) => {
        const value = e.target?.value ?? e;
        setFormData((prev) => ({ ...prev, [field]: value }));
        setFormErrors((prev) => ({ ...prev, [field]: "" })); // clear error on change
      };
    
      const handleSubmit = () => {
        const errors = validateForm(formData, otherDetailsRules);
        setFormErrors(errors);
    
        if (Object.keys(errors).length === 0) {
          nextHandler(formData ,"otherDetails");
        }
      };

 return (
   <div>
      <div className="shadow-card pt-7 pb-3  px-6 rounded-[16px] grid gap-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
  
      <TextFieldCustom label="Vehicle type*" fullWidth 
        value={formData.vechicalType}
            onChange={handleChange("vechicalType")}
            error={!!formErrors.vechicalType}
            helperText={formErrors.vechicalType || " "}/>
      <TextFieldCustom label="License Plate Number*" fullWidth 
        value={formData.licencePlateNumber}
            onChange={handleChange("licencePlateNumber")}
            error={!!formErrors.licencePlateNumber}
            helperText={formErrors.licencePlateNumber || " "} />
    </div>
    <ButtonContainer  handleNext={handleSubmit} handlePrevious={previousHandler} mode= {mode} />
   </div>
  );
}

export default OtherDetails;
